module.exports = __webpack_public_path__ + "img/logo.4dbbacd2.svg";